import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Providers } from '@/app/providers';
import { router } from '@/app/router';
import { initI18n } from '@/i18n/init';
// eslint-disable-next-line import/no-unassigned-import
import '@/styles/globals.css';

/* Datadog RUM weighs ~170 KB gzip and is non-critical for first paint — defer
 * it via a dynamic import so it lands in its own chunk and doesn't bloat the
 * shell entry. We still kick it off ASAP (no `await` on the page render path)
 * so beacons start flowing within a few hundred ms of load. The init function
 * is itself a no-op when credentials are missing. */
void import('@/app/datadog-rum').then((m) => m.initDatadogRum());

async function bootstrap() {
  await initI18n();
  createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </React.StrictMode>,
  );
}

void bootstrap();
